// Error de negocio del motor de cotización. Vive aparte para que `escala.ts` pueda lanzarlo
// sin crear un ciclo de imports con `cotizar.ts`.

export type CodigoErrorCotizacion = 'sin_maquina' | 'no_cabe' | 'sin_material' | 'sin_archivo' | 'otro';

export class ErrorCotizacion extends Error {
  readonly codigo: CodigoErrorCotizacion;
  readonly mensaje: string;
  constructor(codigo: CodigoErrorCotizacion, mensaje: string) {
    super(mensaje);
    this.name = 'ErrorCotizacion';
    this.codigo = codigo;
    this.mensaje = mensaje;
  }
}
